module.exports = __webpack_public_path__ + "img/download.606a68c1.svg";